import React from "react";
import DonutChartComponent from "./base/donutChart";
import { DonutChartData, ExperimentDataPoint } from "./types";
import UmapVisualization from "./umapVisualization";

interface LipidTypesSectionProps {
  helperLipids: DonutChartData[];
  pegLipids: DonutChartData[];
  experimentData: ExperimentDataPoint[];
}

const LipidTypesSection: React.FC<LipidTypesSectionProps> = ({
  helperLipids,
  pegLipids,
  experimentData,
}) => {
  return (
    <div className="mb-8 bg-white rounded-lg shadow-md">
      <div className="p-4 border-b border-gray-200">
        <h2 className="text-xl font-semibold text-gray-800">Lipid Types</h2>
        <p className="mt-1 text-sm text-gray-600">Helper Lipid and PEG Lipid</p>
      </div>
      <div className="p-4">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          <div>
            <DonutChartComponent
              data={helperLipids}
              title="Helper Lipid Type"
              height={400}
              colors={[
                "#0088FE",
                "#00C49F",
                "#FFBB28",
                "#FF8042",
                "#8884d8",
                "#82ca9d",
              ]}
            />
          </div>
          <div>
            <DonutChartComponent
              data={pegLipids}
              title="PEG Lipid Type"
              height={400}
              colors={[
                "#8884d8",
                "#82ca9d",
                "#ffc658",
                "#ff8042",
                "#0088fe",
                "#8dd1e1",
              ]}
            />
          </div>
        </div>
        <div>
          <UmapVisualization data={experimentData} />
        </div>
      </div>
    </div>
  );
};

export default LipidTypesSection;
